<template>
    <component
        :is="componentName"
        :lockedRows="lockedRows"
        :preselectedRows="preselectedRows"
        :to-remove-toolbar-items-names="toRemoveToolbarItemsNames"
        :meta="meta"
        :action="action"
        :toolbarUserItems="toolbarUserItems"
        ref="treeListEditRef"
        :args="args"
        :editing="editing"
        :toolbar-show="toolbarShow"
        :hasntRoute="hasntRoute"
        :showFooter="showFooter"
        @tree-list-focus-changed="onTreeListFocusChanged"
        @mounted="onMountedHandler"
        @user-settings-changed="onUserSettingsChanged"
        @user-data-changed="onUserDataChanged"
        @save-settings="onSaveSettingsHandler"
        @treeListEditMounted="treeListEditWrapperMountedHandler"
        @escapeDownClick="onEscapeDownClick"
        @toolbar-button-click="e => emit('toolbarButtonClick', e)"
        @cell-click="onCellClick"
        @changesSavedSuccessfully="onChangesSavedSuccessfully"
        @refreshEnd="onRefreshHandler"
    />
</template>

<script>
export default {
    name: 'ai-tree-list-edit-wrapper',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';

import { mainState, setIsReloadValue } from '@/layouts/main-layout/main-layout-data';
import { getUserDataChanges, setUserSettingsChanges } from '@/service/userdata-service';
import { tabState } from '@/layouts/main-layout/components/navigation-bars-data';

const emit = defineEmits([
    'toolbarButtonClick',
    'escapeDownClick',
    'treeListEditWrapperMounted',
    'treeListFocusChanged',
    'dataLoaded',
]);
const treeListEditRef = ref();
const componentName = ref('ai-tree-list-edit');

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    action: {
        type: Function,
        default: null,
    },
    args: {
        type: Object,
        default: () => {},
    },
    lockedRows: {
        type: Array,
        default: () => [],
    },
    toolbarShow: {
        type: Boolean,
        default: () => true,
    },
    toRemoveToolbarItemsNames: {
        type: Array,
        default: () => ['moveSave', 'moveTo', 'choice', 'edit'],
    },
    hasntRoute: {
        type: Boolean,
        default: () => false,
    },
    showFooter: {
        type: Boolean,
        default: () => true,
    },
    toolbarUserItems: {
        type: Array,
        default: () => [],
    },
    editing: {
        type: Object,
        default: () => {},
    },
    preselectedRows: {
        type: Array,
        default: () => [],
    },
});

const state = {
    userSettings: null,
};

onMounted(() => {});

const onEscapeDownClick = highlightedRowsElements => {
    emit('escapeDownClick', highlightedRowsElements);
};

const onRefreshHandler = () => {
    emit('refresh');
};

const onUserDataChanged = args => {
    emit('userDataChanged', args);
};

const treeListEditWrapperMountedHandler = () => {
    if (mainState.isReload || props.hasntRoute) {
        treeListEditRef.value.setCacheOrApiDataSource();
        setIsReloadValue(false);
        emit('dataLoaded');
    }
    emit('treeListEditWrapperMounted');
};

const setUserDataFromCacheOrApi = async (args, isNeedResult) => {
    let userChanges;
    if (Object.keys(tabState).length && tabState[window.location.pathname]?.changes) {
        userChanges = isNeedResult
            ? { result: true, gridChanges: tabState[window.location.pathname].changes }
            : tabState[window.location.pathname].changes;
    } else {
        const { result, changes } = await getUserDataChanges({ viewId: props.meta.viewId });

        userChanges = isNeedResult ? { result, changes } : changes;

        tabState[window.location.pathname] ??= {};
        tabState[window.location.pathname].changes = changes;
    }

    if (userChanges?.gridChanges) {
        treeListEditRef.value?.setUserDataChanges(userChanges.gridChanges, true);
    }

    if (userChanges?.rowKey) {
        console.log(' treeListEditRef.value', treeListEditRef.value);
        treeListEditRef.value?.setFocusdRow(userChanges?.rowKey);
    }

    return userChanges;
};

const getUserSettings = () => {
    return { ...state.userSettings };
};

const onSaveSettingsHandler = async () => {
    const userSettings = getUserSettings();

    tabState[window.location.pathname] ??= {};
    if (userSettings) {
        tabState[window.location.pathname].settings = userSettings.settings;
    } else {
        tabState[window.location.pathname].settings = null;
    }

    await setUserSettingsChanges({ settings: userSettings, viewId: props.meta.viewId });
};

const onChangesSavedSuccessfully = () => {
    emit('changesSavedSuccessfully');
};

const onUserSettingsChanged = async (userSettings, autoSaveMode) => {
    if (autoSaveMode) {
        tabState[window.location.pathname] ??= {};
        if (userSettings) {
            tabState[window.location.pathname].settings = userSettings.settings;
        } else {
            tabState[window.location.pathname].settings = null;
        }

        await setUserSettingsChanges(userSettings);
    } else {
        state.userSettings = userSettings.settings;
    }

    emit('userSettingsChanged', userSettings, autoSaveMode);
};

const onTreeListFocusChanged = (row, viewId, rowIndex, component) => {
    emit('treeListFocusChanged', row, viewId, rowIndex, component);
};

const onCellClick = async ({ viewId, event, key }) => {
    emit('cellClick', { viewId, event, key });
};

defineExpose({
    ref: treeListEditRef,
    setUserDataFromCacheOrApi,
});
</script>
